var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-overlay',{attrs:{"opacity":"0.8"}},[_c('v-progress-circular',{attrs:{"size":"50","color":"white","indeterminate":""}}),_c('p',[_vm._v(_vm._s(_vm.description))])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }